/**
 * TypingIndicator Component
 * 
 * Displays animated typing indicator when someone is typing.
 * Shows: "John is typing..." with pulsing dots animation
 * 
 * On mobile: Fixed position above the message composer
 * On desktop: Normal flow in the flex column
 */

import React from 'react';

export default function TypingIndicator({ text }) {
  if (!text) return null;

  return (
    <div data-ui="typing-row" className="
      flex items-center gap-2 px-4 py-2 bg-white/95 dark:bg-[#2d2f33]/95 backdrop-blur-sm
      md:relative md:bottom-auto md:left-auto md:right-auto md:z-auto
      fixed bottom-[calc(100px+env(safe-area-inset-bottom))] left-0 right-0 z-20
      border-t border-slate-100 dark:border-white/10 md:border-0
    ">
      {/* Animated dots */}
      <div data-ui="typing" className="flex items-center gap-1">
        <span 
          className="w-2 h-2 bg-slate-400 rounded-full animate-bounce"
          style={{ animationDelay: '0ms', animationDuration: '600ms' }}
        />
        <span 
          className="w-2 h-2 bg-slate-400 rounded-full animate-bounce"
          style={{ animationDelay: '150ms', animationDuration: '600ms' }}
        />
        <span 
          className="w-2 h-2 bg-slate-400 rounded-full animate-bounce"
          style={{ animationDelay: '300ms', animationDuration: '600ms' }}
        />
      </div>
      
      {/* Typing text */}
      <span data-ui="typing-text" className="text-sm text-slate-500 dark:text-slate-400 italic">
        {text}
      </span>
    </div>
  );
}
